import useScrollReset from "src/hooks/useScrollReset";

const ScrollReset = (): null => {
    useScrollReset();

    return null;
};

export default ScrollReset;
